
import { Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { DisenioProducto } from "../../layout";
import { TarjetasOpciones } from "../../components";
import { useEliminarProducto } from "../../../hooks";

import Swal from "sweetalert2";




export const OpcionesProducto = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { mutationDeleteProducto } = useEliminarProducto();


    
    const handleNavegar = (url) => {
        navigate(`/admin/producto/${id}/${url}`)
    }


    const handleEliminarInfo = async() => {
        const result = await Swal.fire({
            title: 'Eliminar Producto',
            text: '¿Está seguro de eliminar este producto?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        
        if (!result.isConfirmed) return;
        
        await mutationDeleteProducto.mutateAsync(id);
    }




    const data = [
        {key:1, titulo:'Editar Producto', function: handleNavegar, url:'edit', icono:'setting'},
        {key:2, titulo:'Eliminar Producto', function: handleEliminarInfo, url:null, icono:'eliminar'},
        {key:3, titulo:'Stock Producto', function: handleNavegar, url:'stock', icono:'stock'},

    ];


    return (

        <DisenioProducto titulo="Opciones de Producto" url={1}>
            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>
        </DisenioProducto>

    )
}
